import * as classNames from 'classnames';
import * as React from 'react';
import './styles.sass';

export interface ISessionLeftBarProps {
    children?: any;
    hidden?: boolean;
    toggleLeftBar: () => void | undefined;
}

export const SessionLeftBar: React.StatelessComponent<ISessionLeftBarProps>
= ({
  children,
  hidden,
  toggleLeftBar,
}: ISessionLeftBarProps) => (
  <div className={classNames('session-left-bar', {['session-left-bar__hidden']: hidden})}>
    {children}

    {toggleLeftBar &&
      <span className={'session-left-bar__button'} onClick={toggleLeftBar}>
        <span className={'fa fa-close icon icon--animated'} />
      </span>
    }
  </div>
);
